import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditAlojamientoTxComponent } from "./edit-alojamiento-tx/edit-alojamiento-tx.component";

@Component({
  selector: "app-alojamiento-tx",
  templateUrl: "./alojamiento-tx.component.html",
  styleUrls: ["./alojamiento-tx.component.scss"],
})
export class AlojamientoTxComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditAlojamientoTxComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
